import { datadogRum } from '@datadog/browser-rum';

import type {
  InviteEligibilityFinalDecision,
  InviteEligibilityFlow,
  InviteEligibilityPreflightSummary,
  InviteEligibilitySubmitPreflightDecision,
} from './utils/invite-eligibility-telemetry.util';

export const INVITE_ELIGIBILITY_RUM_ACTIONS = {
  PreflightCompleted: 'Invite Eligibility Preflight Completed',
  BlockShown: 'Invite Eligibility Block Shown',
  RecordLinkClicked: 'Invite Eligibility Record Link Clicked',
  SubmitCompleted: 'Invite Eligibility Submit Completed',
} as const;

const buildContext = (flow: InviteEligibilityFlow) => ({
  feature: 'invite_eligibility',
  invite_flow: flow,
});

export const recordInviteEligibilityPreflightCompleted = (
  flow: InviteEligibilityFlow,
  summary: InviteEligibilityPreflightSummary,
) => {
  datadogRum.addAction(INVITE_ELIGIBILITY_RUM_ACTIONS.PreflightCompleted, {
    ...buildContext(flow),
    ...summary,
  });
};

/** Preflight failed open: the form stays usable and no banner is shown. */
export const recordInviteEligibilityPreflightUnavailable = (
  flow: InviteEligibilityFlow,
  renterCount: number,
  httpStatus?: number,
) => {
  const context = {
    ...buildContext(flow),
    decision: 'unavailable',
    renter_count: renterCount,
    ...(httpStatus ? { http_status: httpStatus } : {}),
  };
  datadogRum.addAction(INVITE_ELIGIBILITY_RUM_ACTIONS.PreflightCompleted, context);
  datadogRum.addError(new Error('Invite eligibility preflight unavailable'), context);
};

export const recordInviteEligibilityBlockShown = (
  flow: InviteEligibilityFlow,
  blockCount: number,
) => {
  datadogRum.addAction(INVITE_ELIGIBILITY_RUM_ACTIONS.BlockShown, {
    ...buildContext(flow),
    block_count: blockCount,
  });
};

export const recordInviteEligibilityRecordLinkClicked = (
  flow: InviteEligibilityFlow,
  outcome: string,
  matchCount: number,
) => {
  datadogRum.addAction(INVITE_ELIGIBILITY_RUM_ACTIONS.RecordLinkClicked, {
    ...buildContext(flow),
    outcome,
    match_count: matchCount,
  });
};

export const recordInviteEligibilitySubmitCompleted = (
  flow: InviteEligibilityFlow,
  preflightDecision: InviteEligibilitySubmitPreflightDecision,
  finalDecision: InviteEligibilityFinalDecision,
) => {
  datadogRum.addAction(INVITE_ELIGIBILITY_RUM_ACTIONS.SubmitCompleted, {
    ...buildContext(flow),
    preflight_decision: preflightDecision,
    final_decision: finalDecision,
  });
};
